module.exports = __webpack_public_path__ + "img/camera.c58c4be8.jpg";